var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDynamicLiquidity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 34,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  fillRule: "evenodd",
  d: "M7.36 24.327c0-2.712 6.164-4.908 13.77-4.908 7.607 0 13.773 2.196 13.773 4.908v4.51c0 2.712-6.166 4.909-13.772 4.909-7.607 0-13.77-2.197-13.77-4.909z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECD3D",
  fillRule: "evenodd",
  d: "M21.13 19.419c7.607 0 13.773 2.196 13.773 4.908 0 2.71-6.166 4.909-13.772 4.909-7.607 0-13.77-2.199-13.77-4.909 0-2.712 6.164-4.908 13.77-4.908",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CEA732",
  fillRule: "evenodd",
  d: "M21.13 19.419c2.316 0 4.498.202 6.412.562v.326c0 2.712-6.166 4.908-13.77 4.908-2.303 0-4.473-.2-6.381-.556q-.03-.165-.03-.332c0-2.712 6.163-4.908 13.77-4.908",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  fillRule: "evenodd",
  d: "M21.13 21.71c6.053 0 10.957 1.173 10.957 2.617S27.182 26.94 21.13 26.94s-10.956-1.17-10.956-2.613S15.08 21.71 21.13 21.71",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CE8829",
  fillRule: "evenodd",
  d: "M21.13 21.71c2.005 0 3.885.13 5.502.355-1.986 1.842-6.994 3.15-12.86 3.15-1.075 0-2.12-.044-3.125-.127-.306-.242-.472-.497-.472-.761 0-1.444 4.906-2.616 10.956-2.616",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C85929",
  d: "M31.178 29.792v2.401a13 13 0 0 0 1.178-.513v-1.89zM28.1 33.071q-.57.12-1.176.22v-2.288l1.176.002zm-4.254.578q-.58.043-1.176.066V31.53l1.176.005zm-4.254.066a36 36 0 0 1-1.178-.066v-2.117h1.178zm-4.256-.424a29 29 0 0 1-1.176-.22v-2.068l1.176.002zm-4.254-1.098a13 13 0 0 1-1.178-.513v-1.888l1.178-.002z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  fillRule: "evenodd",
  d: "M0 14.62c0-2.712 6.166-4.911 13.772-4.911 7.604 0 13.77 2.199 13.77 4.91v4.51c0 2.71-6.166 4.909-13.77 4.909C6.166 24.038 0 21.838 0 19.129z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECD3D",
  fillRule: "evenodd",
  d: "M13.772 9.709c7.604 0 13.77 2.199 13.77 4.91 0 2.71-6.166 4.909-13.77 4.909C6.166 19.528 0 17.329 0 14.62c0-2.712 6.166-4.911 13.772-4.911",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#CEA732",
  fillRule: "evenodd",
  d: "M13.772 9.709c7.604 0 13.77 2.199 13.77 4.91q0 .4-.176.784a41 41 0 0 1-4.613.253c-8.396 0-15.202-2.425-15.202-5.417 1.867-.338 3.982-.53 6.221-.53",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  fillRule: "evenodd",
  d: "M13.772 12.004c6.05 0 10.957 1.172 10.957 2.616s-4.907 2.613-10.957 2.613-10.956-1.17-10.956-2.613 4.905-2.616 10.956-2.616",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#CE8829",
  fillRule: "evenodd",
  d: "M13.772 12.004c6.05 0 10.956 1.172 10.956 2.616 0 .362-.311.71-.874 1.022q-.546.015-1.102.015c-6.346 0-11.782-1.385-14.06-3.354 1.519-.19 3.245-.3 5.08-.3",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C85929",
  d: "M23.82 20.083v2.401q.636-.243 1.178-.513v-1.89zm-3.078 3.279q-.57.12-1.176.22v-2.288l1.176.002zm-4.256.578q-.579.043-1.176.066v-2.184l1.176.002zm-4.254.066q-.596-.024-1.178-.066v-2.117l1.178-.002zm-4.256-.424a30 30 0 0 1-1.176-.22v-2.068l1.176.002zm-4.252-1.098a13 13 0 0 1-1.18-.513v-1.888l1.18-.002z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  d: "M34.874 15.39v1.057h1.056v1.01h-1.056v1.056h-1.01v-1.056h-1.055v-1.01h1.055V15.39zM3.205 26.115v1.056h1.056v1.01H3.205v1.055h-1.01v-1.055H1.138v-1.01h1.057v-1.056zM3.204 4.037v1.055H4.26v1.01H3.204V7.16h-1.01V6.103H1.137v-1.01h1.057V4.036z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  fillRule: "evenodd",
  d: "M7.36 4.908C7.36 2.198 13.524 0 21.13 0c7.607 0 13.773 2.199 13.773 4.908V9.42c0 2.71-6.166 4.909-13.772 4.909-7.607 0-13.77-2.199-13.77-4.909z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECD3D",
  fillRule: "evenodd",
  d: "M21.13 0c7.607 0 13.773 2.199 13.773 4.908 0 2.712-6.166 4.91-13.772 4.91-7.607 0-13.77-2.198-13.77-4.91C7.36 2.198 13.524 0 21.13 0",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  fillRule: "evenodd",
  d: "M21.13 2.295c6.053 0 10.957 1.17 10.957 2.614 0 1.446-4.905 2.615-10.956 2.615S10.175 6.354 10.175 4.91c0-1.444 4.906-2.614 10.956-2.614",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#C85929",
  d: "M31.178 10.375v2.401q.637-.243 1.178-.513v-1.89zM28.1 13.653q-.57.12-1.176.22v-2.287l1.176.002zm-4.254.58q-.58.04-1.176.065v-2.184l1.176.002zm-4.254.065a43 43 0 0 1-1.178-.066v-2.116l1.178-.002zm-4.256-.426q-.605-.098-1.176-.219v-2.067l1.176.002zm-4.254-1.096a13 13 0 0 1-1.178-.513v-1.888l1.178-.002z"
})));
export default SvgDynamicLiquidity;